export default __webpack_public_path__ + "static-front/media/Logo.fffcffa4.svg";